import { memo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import $ from "jquery";

import imgselect from "../../assets/images/select_box.png";
import Pagination from "../Pagination/Pagination";
import Loader from "../resuableComponent/loader";
import EditTaskPopup from "./EditTaskPopup";
import TaskNAssignee from "./components/Task_n_Assignee";

import RemediationActionButton from "../common/RemediationActionButton";

import {
  getOverviewList,
  removeTicket,
  updateTicket,
} from "../../actions/remediationMode";

const RemediationOverview = () => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState("all");
  const auth = useSelector((state) => state?.auth?.user);
  const id = useSelector((state) => {
    return (
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
    );
  });
  const list = useSelector((state) => {
    return state?.remediationMode?.list?.data;
  });
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(1);
  const [containerClass, setContainerClass] = useState("data-container");
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  useEffect(() => {
    getOverviewList(id, dispatch, page, "task", category);
  }, [category, dispatch, id, page]);

  useEffect(() => {
    if (list?.tickets) {
      setTimeout(() => {
        setContainerClass("data-container active");
      }, 300);
    }
  }, [list?.tickets]);

  const removeRemediationData = (recordId) => (e) => {
    $.confirm({
      title: "Are you sure?",
      content:
        "Do you really want to remove this from the Remediation List Panel?",
      type: "red",
      buttons: {
        ok: {
          text: "Remove",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            removeTicket(recordId, id, dispatch, "task", category);
          },
        },
        cancel: function () {},
      },
    });
  };

  const updateTicketFunction = (_id, data) => {
    updateTicket(_id, data, id, dispatch, "task", category);
  };

  return (
    <div>
      {list ? (
        <div className={containerClass}>
          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9" style={{ padding: "0" }}>
              <div className="row_boxes row_boxes_table">
                {/* Tab Navigation */}
                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                  <li className="nav-item">
                    <span
                      className={`nav-table-tab nav-link ${
                        category === "all" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("all");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "task", "");
                      }}
                    >
                      Overview
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "InProgress" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("InProgress");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "task", "InProgress");
                      }}
                    >
                      In Process
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "Close" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("Close");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "task", "Close");
                      }}
                    >
                      Completed
                    </span>
                  </li>
                </ul>
                <div
                  className="table_box"
                  style={{ minHeight: "400px !important" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        {/* {auth?.accessLevel != "Threat Analyst" &&
                          (category === "all" ||
                            category === "risk-accepted" ||
                            category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  // multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )} */}

                        <th>
                          {auth?.accessLevel != "Threat Analyst" &&
                            (category === "all" ||
                              category === "risk-accepted" ||
                              category === "false-positive") && (
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  // multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            )}
                        </th>
                        <th>Date Added</th>
                        <th>Task Id</th>
                        <th>Type</th>
                        <th>Details</th>
                        <th>Notes</th>
                        <th>Rating</th>
                        <th>Priority</th>
                        <th>Task</th>
                        <th>Assigned</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        <th>Last Updated</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {list?.tickets?.map((r) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedIds == 0 ? false : multiCheckTrue
                                  }
                                  onClick={() => {
                                    // multicheck(currentTableData);
                                  }}
                                  className="checkUncheck"
                                />
                              </td>
                              <td>
                                {r?.createdAt
                                  ? moment(r?.createdAt).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>{r?.taskId || "N/A"}</td>
                              {/* <td>{r?.actionType || "N/A"}</td> */}
                              <td>
                                {r?.findingDetails?.specificInfo || "N/A"}
                              </td>
                              <td>{r?.findingDetails?.detail || "N/A"}</td>
                              <td>{r?.note || "N/A"}</td>
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.rating}
                                    onChange={(e) => {
                                      //  setRating(e.target.value); -- JK : Removed Unused
                                      let data = {
                                        rating: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.priority}
                                    onChange={(e) => {
                                      // setRating(e.target.value); -- JK : Removed Unused
                                      let data = {
                                        priority: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <TaskNAssignee
                                item={r}
                                updateTicketFunction={updateTicketFunction}
                                OrgId={id}
                                imgselect={imgselect}
                              />
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.status}
                                    onChange={(e) => {
                                      let data = {
                                        status: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Open">Open</option>
                                    <option value="InProgress">
                                      In Progress
                                    </option>
                                    <option value="Close">Completed</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <td>
                                {r?.dueDate
                                  ? moment(r?.dueDate).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>
                                {r?.updatedAt
                                  ? moment(r?.updatedAt).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>
                                <span
                                  className="openTask"
                                  onClick={() => {
                                    setSelectedTask(r);
                                    setIsPopupOpen(true);
                                  }}
                                >
                                  Open Task
                                </span>
                              </td>
                              <RemediationActionButton
                                onRemove={() =>
                                  removeRemediationData(r?.recordId)
                                }
                                shouldShowPlus={false}
                              />
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="dataTables_paginate">
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={10}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
      {isPopupOpen && (
        <EditTaskPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          taskData={selectedTask}
        />
      )}
    </div>
  );
};

export default memo(RemediationOverview);
